import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../';
import Popup from './Popup';
import { ContextConsumer } from './Context';
import NavItem from './NavItem';
import NavMenuHeading from './NavMenuHeading';
import NavMenuItem from './NavMenuItem';
import NavTooltip from './NavTooltip';
import SidebarExpandToggle from './SidebarExpandToggle'; // needs to equal @navPopupSpacing value from
// src/modules/CommonChrome/styles/variables.less

var SIDEBAR_TOOLTIP_POPPER_OFFSET = 15; // needs to equal @navPopupSpacing + @navItemSize
// using values from
// src/modules/CommonChrome/styles/variables.less

var SIDEBAR_POPPER_OFFSET = 55; // needs to equal @navSubmenuWidth - (@navSpacing / 2)
// using values from
// src/modules/CommonChrome/styles/variables.less

var SIDEBAR_NESTED_POPPER_OFFSET = 225;

var Sidebar = /*#__PURE__*/function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    var _this;

    _classCallCheck(this, Sidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // currently expanded submenus
      expandedKeys: {}
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.expanded && _this.initExpandedKeys();
    });

    _defineProperty(_assertThisInitialized(_this), "initExpandedKeys", function () {
      var activeKeys = _this.getActiveLinkKeys(_this.props.links, _this.props.activeKey);

      var expandedKeys = _this.convertLinkKeysToExpandedKeys(activeKeys);

      _this.setState({
        expandedKeys: expandedKeys
      });
    });

    _defineProperty(_assertThisInitialized(_this), "convertLinkKeysToExpandedKeys", function (linkKeys) {
      return linkKeys.reduce(function (expandedKeys, key) {
        return _objectSpread(_objectSpread({}, expandedKeys), {}, _defineProperty({}, key, true));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveLinkKeys", function (links, activeKey) {
      var activeKeys = [];
      links.forEach(function (link) {
        if (link.key === activeKey) {
          activeKeys = [].concat(_toConsumableArray(activeKeys), [link.key]);
        } else if (link.links) {
          var activeSubKeys = _this.getActiveLinkKeys(link.links, activeKey);

          if (activeSubKeys.length) {
            activeKeys = [].concat(_toConsumableArray(activeKeys), _toConsumableArray(activeSubKeys), [link.key]);
          }
        }
      });
      return activeKeys;
    });

    _defineProperty(_assertThisInitialized(_this), "setExpandedKeys", function (expandedKeys) {
      _this.setState({
        expandedKeys: expandedKeys
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSubmenuExpanded", function (key) {
      var subLinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$state$expandedK = _this.state.expandedKeys,
          expandedKeys = _this$state$expandedK === void 0 ? {} : _this$state$expandedK; // collapse submenu if already expanded, otherwise expand

      if (expandedKeys[key]) {
        delete expandedKeys[key]; // also collapse any expanded nested submenus

        subLinks.forEach(function (subLink) {
          delete expandedKeys[subLink.key];
        });
      } else {
        expandedKeys[key] = true;
      }

      _this.setState({
        expandedKeys: expandedKeys
      });
    });

    _defineProperty(_assertThisInitialized(_this), "collapseSubmenu", function (key) {
      var subLinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$state$expandedK2 = _this.state.expandedKeys,
          expandedKeys = _this$state$expandedK2 === void 0 ? {} : _this$state$expandedK2;

      if (expandedKeys[key]) {
        delete expandedKeys[key]; // also collapse any expanded nested submenus

        subLinks.forEach(function (subLink) {
          delete expandedKeys[subLink.key];
        });
      }

      _this.setState({
        expandedKeys: expandedKeys
      });
    });

    _defineProperty(_assertThisInitialized(_this), "expandSubmenu", function (key) {
      var _this$state$expandedK3 = _this.state.expandedKeys,
          expandedKeys = _this$state$expandedK3 === void 0 ? {} : _this$state$expandedK3;
      expandedKeys[key] = true;

      _this.setState({
        expandedKeys: expandedKeys
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuOpen", function (key) {
      _this.expandSubmenu(key);

      _this.props.setHasOpenMenu(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuClose", function (key) {
      var subLinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      _this.collapseSubmenu(key, subLinks);

      _this.props.setHasOpenMenu(false);
    });

    return _this;
  }

  _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          _this$props$links = _this$props.links,
          links = _this$props$links === void 0 ? [] : _this$props$links,
          expanded = _this$props.expanded,
          DefaultLinkWrapper = _this$props.LinkWrapper,
          inverted = _this$props.inverted,
          setExpanded = _this$props.setExpanded;
      var _this$state$expandedK4 = this.state.expandedKeys,
          expandedKeys = _this$state$expandedK4 === void 0 ? {} : _this$state$expandedK4;
      var activeLinkKeys = this.getActiveLinkKeys(links, activeKey);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('cloud-ui-nav-chrome sidebar', {
          expanded: expanded
        }),
        ref: this.setRef,
        "data-qa": "sidebar"
      }, /*#__PURE__*/React.createElement("ul", {
        className: classNames('cloud-ui-nav vertical', {
          expanded: expanded,
          inverted: inverted
        })
      }, links.map(function (_ref) {
        var key = _ref.key,
            href = _ref.href,
            label = _ref.label,
            icon = _ref.icon,
            noDefaultHeading = _ref.noDefaultHeading,
            _ref$links = _ref.links,
            subLinks = _ref$links === void 0 ? [] : _ref$links,
            _ref$LinkWrapper = _ref.LinkWrapper,
            LinkWrapper = _ref$LinkWrapper === void 0 ? DefaultLinkWrapper : _ref$LinkWrapper,
            linkProps = _objectWithoutProperties(_ref, ["key", "href", "label", "icon", "noDefaultHeading", "links", "LinkWrapper"]);

        var hasSub = subLinks.length > 0;
        var subExpanded = !!expandedKeys[key];

        var _onClose = function onClose() {
          return _this2.onMenuClose(key, subLinks);
        };

        var item = hasSub ? /*#__PURE__*/React.createElement(NavItem, _extends({
          "data-qa": "sidebar-".concat(key)
        }, linkProps, {
          href: href,
          icon: icon,
          isActive: activeLinkKeys.includes(key),
          isOpen: subExpanded,
          hasSub: true,
          LinkWrapper: LinkWrapper,
          onClick: function onClick() {
            var onClick = linkProps.onClick;

            if (typeof onClick === 'function') {
              onClick();
            }

            if (expanded) {
              _this2.toggleSubmenuExpanded(key, subLinks);
            }
          }
        }), expanded && label, /*#__PURE__*/React.createElement(Icon, {
          className: "sub-arrow down",
          name: "chevron-down"
        }), !expanded && !subExpanded && /*#__PURE__*/React.createElement(Icon, {
          className: "sub-arrow right",
          name: "chevron-right"
        })) : /*#__PURE__*/React.createElement(NavItem, _extends({
          "data-qa": "sidebar-".concat(key)
        }, linkProps, {
          href: href,
          icon: icon,
          isActive: activeLinkKeys.includes(key),
          LinkWrapper: LinkWrapper
        }), expanded && /*#__PURE__*/React.createElement("span", {
          className: "label"
        }, label));
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, /*#__PURE__*/React.createElement(NavTooltip, {
          className: "sidebar",
          position: "right center",
          inverted: inverted,
          disabled: expanded || subExpanded,
          offset: [0, SIDEBAR_TOOLTIP_POPPER_OFFSET],
          trigger: hasSub && !expanded ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Popup, {
            className: "sidebar sub",
            position: "bottom left",
            open: !!subExpanded,
            on: "click",
            onOpen: function onOpen() {
              return _this2.onMenuOpen(key);
            },
            onClose: function onClose() {
              return setTimeout(_onClose, 0);
            },
            inverted: inverted,
            trigger: item,
            offset: [SIDEBAR_POPPER_OFFSET, 0]
          }, !noDefaultHeading && /*#__PURE__*/React.createElement(NavMenuHeading, null, label), subLinks.map(function (_ref2) {
            var subKey = _ref2.key,
                subLabel = _ref2.label,
                heading = _ref2.heading,
                _ref2$LinkWrapper = _ref2.LinkWrapper,
                SubLinkWrapper = _ref2$LinkWrapper === void 0 ? LinkWrapper : _ref2$LinkWrapper,
                _ref2$links = _ref2.links,
                subSubLinks = _ref2$links === void 0 ? [] : _ref2$links,
                subLinkProps = _objectWithoutProperties(_ref2, ["key", "label", "heading", "LinkWrapper", "links"]);

            if (subSubLinks.length > 0) {
              var active = activeKey === subKey || !!subSubLinks.find(function (l) {
                return l.key === activeKey;
              });

              var onSubClose = function onSubClose() {
                _this2.onMenuClose(subKey);
              };

              var subSubExpanded = !!expandedKeys[subKey];
              var subItem = /*#__PURE__*/React.createElement(NavMenuItem, _extends({
                "data-qa": "sidebar-".concat(key, "-").concat(subKey),
                hasSub: true
              }, subLinkProps, {
                isActive: active,
                isOpen: !!subSubExpanded,
                LinkWrapper: SubLinkWrapper
              }), subLabel, subLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
                name: "external-link-small"
              }), /*#__PURE__*/React.createElement(Icon, {
                className: "sub-arrow right",
                name: "chevron-right"
              }));
              return /*#__PURE__*/React.createElement("div", {
                key: "".concat(key, "-").concat(subKey)
              }, /*#__PURE__*/React.createElement(Popup, {
                className: "sidebar sub nested",
                position: "bottom left",
                open: !!subSubExpanded,
                on: "click",
                onOpen: function onOpen() {
                  return _this2.onMenuOpen(subKey);
                },
                onClose: onSubClose,
                inverted: inverted,
                trigger: subItem,
                offset: [SIDEBAR_NESTED_POPPER_OFFSET, 0]
              }, subSubLinks.map(function (_ref3) {
                var subSubKey = _ref3.key,
                    subSubLabel = _ref3.label,
                    subHeading = _ref3.heading,
                    _ref3$LinkWrapper = _ref3.LinkWrapper,
                    SubSubLinkWrapper = _ref3$LinkWrapper === void 0 ? LinkWrapper : _ref3$LinkWrapper,
                    subSubLinkProps = _objectWithoutProperties(_ref3, ["key", "label", "heading", "LinkWrapper"]);

                return subHeading ? /*#__PURE__*/React.createElement(NavMenuHeading, {
                  key: subSubKey
                }, subSubLabel) : /*#__PURE__*/React.createElement(NavMenuItem, _extends({
                  key: subSubKey,
                  "data-qa": "sidebar-".concat(key, "-").concat(subKey, "-").concat(subSubKey)
                }, subSubLinkProps, {
                  isActive: activeKey === subSubKey,
                  LinkWrapper: SubSubLinkWrapper,
                  onClick: function onClick() {
                    var onClick = subSubLinkProps.onClick;

                    if (typeof onClick === 'function') {
                      onClick();
                    }

                    onSubClose();
                  }
                }), subSubLabel, subSubLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
                  name: "external-link-small"
                }));
              })));
            } else {
              return heading ? /*#__PURE__*/React.createElement(NavMenuHeading, {
                key: subKey
              }, subLabel) : /*#__PURE__*/React.createElement(NavMenuItem, _extends({
                key: subKey,
                "data-qa": "sidebar-".concat(key, "-").concat(subKey)
              }, subLinkProps, {
                isActive: activeKey === subKey,
                LinkWrapper: SubLinkWrapper,
                onClick: function onClick() {
                  var onClick = subLinkProps.onClick;

                  if (typeof onClick === 'function') {
                    onClick();
                  }

                  _onClose();
                }
              }), subLabel, subLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
                name: "external-link-small"
              }));
            }
          }))) : item,
          content: label
        }), expanded && subLinks && /*#__PURE__*/React.createElement("ul", {
          className: classNames('nav-sub-list', {
            hidden: !subExpanded
          })
        }, subLinks.map(function (_ref4) {
          var subKey = _ref4.key,
              subHref = _ref4.href,
              subLabel = _ref4.label,
              heading = _ref4.heading,
              _ref4$LinkWrapper = _ref4.LinkWrapper,
              SubLinkWrapper = _ref4$LinkWrapper === void 0 ? LinkWrapper : _ref4$LinkWrapper,
              _ref4$links = _ref4.links,
              subSubLinks = _ref4$links === void 0 ? [] : _ref4$links,
              subLinkProps = _objectWithoutProperties(_ref4, ["key", "href", "label", "heading", "LinkWrapper", "links"]);

          var hasSubSub = subSubLinks.length > 0;
          var subSubExpanded = !!expandedKeys[subKey];
          return heading ? /*#__PURE__*/React.createElement(NavMenuHeading, {
            key: subKey
          }, subLabel) : /*#__PURE__*/React.createElement("li", {
            key: subKey
          }, /*#__PURE__*/React.createElement(NavItem, _extends({
            "data-qa": "sidebar-".concat(key, "-").concat(subKey)
          }, subLinkProps, {
            href: subHref,
            isActive: activeLinkKeys.includes(subKey),
            LinkWrapper: SubLinkWrapper,
            isOpen: subSubExpanded,
            hasSub: hasSubSub,
            onClick: function onClick() {
              var onClick = subLinkProps.onClick;

              if (typeof onClick === 'function') {
                onClick();
              }

              if (hasSubSub) {
                _this2.toggleSubmenuExpanded(subKey);
              }
            }
          }), subLabel, subLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
            name: "external-link-small"
          }), hasSubSub && /*#__PURE__*/React.createElement(Icon, {
            className: "sub-arrow down",
            name: "chevron-down"
          })), hasSubSub && /*#__PURE__*/React.createElement("ul", {
            className: classNames('nav-sub-list', {
              hidden: !subSubExpanded
            })
          }, subSubLinks.map(function (_ref5) {
            var subSubKey = _ref5.key,
                subSubLabel = _ref5.label,
                subHeading = _ref5.heading,
                _ref5$LinkWrapper = _ref5.LinkWrapper,
                SubSubLinkWrapper = _ref5$LinkWrapper === void 0 ? LinkWrapper : _ref5$LinkWrapper,
                subSubLinkProps = _objectWithoutProperties(_ref5, ["key", "label", "heading", "LinkWrapper"]);

            return /*#__PURE__*/React.createElement("li", {
              key: subSubKey
            }, /*#__PURE__*/React.createElement(NavItem, _extends({
              "data-qa": "sidebar-".concat(key, "-").concat(subKey, "-").concat(subSubKey)
            }, subSubLinkProps, {
              LinkWrapper: SubSubLinkWrapper,
              isActive: activeKey === subSubKey
            }), subSubLabel, subSubLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
              name: "external-link-small"
            })));
          })));
        })));
      })), /*#__PURE__*/React.createElement(SidebarExpandToggle, {
        expanded: expanded,
        inverted: inverted,
        setExpanded: setExpanded,
        setExpandedKeys: this.setExpandedKeys
      }));
    }
  }]);

  return Sidebar;
}(React.Component);

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref6) {
    var activeKey = _ref6.activeKey,
        expanded = _ref6.expanded,
        hasLinks = _ref6.hasLinks,
        links = _ref6.links,
        LinkWrapper = _ref6.LinkWrapper,
        setExpanded = _ref6.setExpanded,
        setHasOpenMenu = _ref6.setHasOpenMenu;
    return hasLinks || props.links ? /*#__PURE__*/React.createElement(Sidebar, _extends({
      activeKey: activeKey,
      expanded: expanded,
      setExpanded: setExpanded,
      forwardedRef: ref,
      links: links,
      LinkWrapper: LinkWrapper,
      setHasOpenMenu: setHasOpenMenu
    }, props)) : null;
  });
});